module.exports = __webpack_public_path__ + "static/media/image-card-6.4cc8f5b2.png";